import createAction from 'services/createAction';

const GET_BADGES = 'badges/GET';
const GET_BADGES_SUCCESS = 'badges/GET_SUCCESS';
const GET_BADGES_FAILED = 'badges/GET_FAILED';

const initialState = {
  data: [],
  error: {
    message: '',
  },
  loading: {
    badges: false,
  },
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case GET_BADGES:
    return {
      ...state,
      error: { message: '' },
      loading: { ...state.loading, badges: true },
    };
  case GET_BADGES_SUCCESS:
    return {
      ...state,
      data: payload,
      loading: { ...state.loading, badges: false },
    };
  case GET_BADGES_FAILED:
    return {
      ...state,
      error: { message: payload },
      loading: { ...state.loading, badges: false },
    };
  default:
    return state;
  }
};

const getBadgesSuccess = createAction(GET_BADGES_SUCCESS);
const getBadgesFailed = createAction(GET_BADGES_FAILED);

export const getBadges = () => (dispatch, getState, api) => {
  dispatch({ type: GET_BADGES });

  api.get({ path: 'badges', v2: true })
    .then((res) => {
      dispatch(getBadgesSuccess(res));
    })
    .catch((err) => {
      dispatch(getBadgesFailed({ message: err.data }));
    });
};
